import { paginated_factory_v2, backend_api_v2 } from '/src/utils/apiv2'
import { today } from '/src/utils/time'
import { useAppStore } from '/src/stores/app'
import bus from '/src/utils/event_bus'

let LASTS = {}

export default {
    actions: {
        // MULTIPLE
        setter(store_keyword) {
            function setter_mutation(data) {
                this[store_keyword] = data
            }
            return setter_mutation
        },
        // SINGLE
        creator(store_keyword) {
            function creator_mutation(data) {
                this[store_keyword].push(data)
            }
            return creator_mutation
        },
        updater(store_keyword) {
            function updater_mutation(updated) {
                let i = this[store_keyword].findIndex(obj => (obj?.uuid || obj.id) == (updated?.uuid || updated.id))
                if (i != -1) {
                    this[store_keyword][i] = updated
                    this[store_keyword] = [...this[store_keyword]]
                }
            }
            return updater_mutation
        },
        remover(store_keyword) {
            function remover_mutation(uuid) {
                this[store_keyword] = [...this[store_keyword].filter(obj => (obj?.uuid || obj.id) != uuid)]
            }
            return remover_mutation
        },


        // MULTIPLE
        loader(url, objs_name) {
            function loader_action() {
                return paginated_factory_v2(url)
                    .then(({ data }) => {
                        this['set' + objs_name](data)
                        return data
                    })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
            }
            return loader_action
        },
        loader_query(url, objs_name) {
            const keyword = `${url}__${objs_name}`
            function loader_action(payload) {

                let query = Object.keys(payload).map(key => key + '=' + payload[key]).join('&')
                // Register last call (ensure last called fills)
                LASTS[keyword] = query

                return paginated_factory_v2(`${url}/?${query}`)
                    .then(({ data }) => {
                        // Accept last
                        if (LASTS[keyword] == query)
                            this['set' + objs_name](data)
                        // Reject prebounce
                        else console.log("[i] Rejecting loader commit. Not last call.")
                        return data
                    })
                    // Its callers (store watchers, a timer) do not wait for it,
                    // so a rejection here went unhandled to Sentry: typically
                    // the 403 of a session that expired (PIT-GCP-FRONT-58).
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
            }
            return loader_action
        },
        loader_pr(url, objs_name) {
            const keyword = `${url}__${objs_name}`
            function loader_action(project_uuid) {
                const app_store = useAppStore()
                app_store.pushLoading(objs_name)

                // Register last call (ensure last called fills). The token is
                // namespaced because loader_date writes this same array under
                // the same key: whichever family called last owns the commit.
                const token = `pr:${project_uuid}`
                LASTS[keyword] = token

                // Clean previous
                this['set' + objs_name]([])

                // If project is "all", query as null
                let query_pr = project_uuid == "all" ? null : project_uuid
                return paginated_factory_v2(`${url}?project=${query_pr}`)
                    .then(({ data }) => {
                        // Accept last
                        if (LASTS[keyword] == token)
                            this['set' + objs_name](data)
                        // Reject prebounce
                        else console.log("[i] Rejecting loader commit. Not last call.")
                        return data
                    })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
                    .finally(() => app_store.popLoading(objs_name))
            }
            return loader_action
        },
        loader_date(url, objs_name) {
            // Same key as loader_pr for this array, not a `__bydate` one of its
            // own: the by-date and by-project loaders fill the very same list,
            // and with separate keys each one passed its own check and the
            // slower response overwrote the other's. Going company-wide from a
            // project (or back) leaves both families in flight at once.
            const keyword = `${url}__${objs_name}`
            function loader_action(prod_date) {
                const app_store = useAppStore()
                // Same loader name as loader_pr, for the same reason the key is
                // shared: the name stands for the list being filled, not for
                // the query that fills it. A table asking for "Assemblies"
                // gets its answer in by-date mode too.
                app_store.pushLoading(objs_name)

                // Register last call (ensure last called fills)
                const token = `date:${prod_date}`
                LASTS[keyword] = token

                // Clean previous
                this['set' + objs_name]([])

                // If today, previous panels are also needed
                let api_promise
                if (prod_date == today()) {
                    api_promise = backend_api_v2(`${url}today_and_delayed/`)
                } else {
                    api_promise = paginated_factory_v2(`${url}?scheduled_prod_date=${prod_date}`)
                }

                return api_promise.then(({ data }) => {
                    // Accept last
                    if (LASTS[keyword] == token)
                        this['set' + objs_name](data)
                    // Reject prebounce
                    else console.log("[i] Rejecting loader commit. Not last call.")
                    return data
                })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
                    .finally(() => app_store.popLoading(objs_name))
            }
            return loader_action
        },
        loader_query(url, objs_name) {
            // Same key as loader_pr and loader_date: all three fill the same
            // array, so whichever was called last owns the commit. Unlike them
            // it does not empty the list first, so a table reloading a new
            // range keeps showing the old rows under its loading bar.
            const keyword = `${url}__${objs_name}`
            function loader_action(params = {}) {
                const app_store = useAppStore()
                app_store.pushLoading(objs_name)

                const query = new URLSearchParams(
                    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
                ).toString()
                const token = `query:${query}`
                LASTS[keyword] = token

                return paginated_factory_v2(`${url}?${query}`)
                    .then(({ data }) => {
                        if (LASTS[keyword] == token)
                            this['set' + objs_name](data)
                        else console.log("[i] Rejecting loader commit. Not last call.")
                        return data
                    })
                    .catch(e => {
                        console.log(`Cant get ${objs_name}: ${e}`)
                    })
                    .finally(() => app_store.popLoading(objs_name))
            }
            return loader_action
        },

        // SINGLE
        poster(url, obj_name) {
            function poster_action(payload) {
                return backend_api_v2.post(url, payload)
                    .then(({ data }) => {
                        this['create' + obj_name](data)
                        return { data }
                    })
                    .catch(e => {
                        bus.emit('notification', { timeout: 5000, text: `Can't create ${obj_name}: ${JSON.stringify(e.response?.data)}`, color: "error" })
                    })
            }
            return poster_action
        },
        putter(url, obj_name) {
            function putter_action(payload) {
                return backend_api_v2.put(url + (payload?.uuid || payload.id) + "/", payload)
                    .then(({ data }) => {
                        this['update' + obj_name](data)
                        return { data }
                    })
                    .catch(e => {
                        bus.emit('notification', { timeout: 5000, text: `Can't update ${obj_name}: ${JSON.stringify(e.response?.data)}`, color: "error" })
                    })
            }
            return putter_action
        },
        deleter(url, obj_name) {
            function deleter_action(uuid) {
                return backend_api_v2.delete(url + uuid + '/')
                    .then(() => {
                        this['remove' + obj_name](uuid)
                    })
                    .catch(e => console.log(`Cant delete ${obj_name}: ${e}`))
            }
            return deleter_action
        },
        refresher(url, obj_name) {
            function refresher_action(uuid) {
                return backend_api_v2.get(url + uuid + "/")
                    .then(({ data }) => {
                        this['update' + obj_name](data)
                        return { data }
                    })
                    .catch(e => console.log(`Cant update ${obj_name}: ${e}`))
            }
            return refresher_action
        },
        poller(url, obj_name, store_keyword) {
            function poller_action(scope_params, since) {
                // Use today_and_delayed endpoint when polling for today's date
                // `since` is a server timestamp with its offset: the `+` must be
                // encoded or it reaches the API as a space.
                const since_param = encodeURIComponent(since)
                let query
                if (scope_params.scheduled_prod_date === today()) {
                    query = `${url}today_and_delayed/?modified__gte=${since_param}`
                } else {
                    query = `${url}?modified__gte=${since_param}`
                    for (const [key, value] of Object.entries(scope_params)) {
                        if (value != null) query += `&${key}=${value}`
                    }
                }
                // Every page: after a bulk change of more than one page (set
                // ready, kits, generate) the rest used to never arrive.
                // today_and_delayed answers one unpaged list.
                const fetchAll = (next, rows = []) => backend_api_v2.get(next)
                    .then(({ data }) => {
                        if (!data.results) return data
                        rows.push(...data.results)
                        return data.next ? fetchAll(data.next, rows) : rows
                    })
                return fetchAll(query)
                    .then(results => {
                        if (results.length === 0) return results
                        // Only update items already in the store, never add new
                        // ones; and only those that changed, since the newest
                        // row comes back on every poll (`modified__gte`).
                        const current = new Map(this[store_keyword].map(obj => [obj.uuid, obj]))
                        const updated_map = new Map(
                            results.filter(obj => current.has(obj.uuid)
                                                  && current.get(obj.uuid).modified !== obj.modified)
                                   .map(obj => [obj.uuid, obj])
                        )
                        if (updated_map.size === 0) return results
                        this[store_keyword] = this[store_keyword].map(item => {
                            return updated_map.get(item.uuid) || item
                        })
                        return results
                    })
                    .catch(e => console.log(`Cant poll ${obj_name}: ${e}`))
            }
            return poller_action
        },
        multi_refresher(url, obj_name, use_post = false) {
            function refresher_action(uuids) {
                if (!uuids?.length) {
                    // Return a fulfilled promise with an empty object if the uuids came empty
                    return Promise.resolve({ data: { results: [] } });
                    // Otherwise, the backend gets an empty filter so it returns a non filtered query
                }
                if (use_post) {
                    return backend_api_v2.post(`${url}get_by_uuids/`, uuids)
                        .then(({ data }) => {
                            data.forEach(obj => this['update' + obj_name](obj))
                            console.log(data)
                            return { data }
                        }).catch(e => console.log(`Cant update ${obj_name}: ${e}`))
                } else {
                    return backend_api_v2.get(`${url}?uuid__in=${uuids.join(",")}`)
                        .then(({ data }) => {
                            data.results.forEach(obj => this['update' + obj_name](obj))
                            return { data }
                        }).catch(e => console.log(`Cant update ${obj_name}: ${e}`))
                }
            }
            return refresher_action
        },
    }
}